
import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const addRecruitAgent = createAsyncThunk("agentRecruitment/addRecruitAgent", async (data, thunkAPI) => {
  try {
    const resp = await axios.post(`${process.env.REACT_APP_BASE_URL}api/recruitment/createAgent`, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return resp.data;
  } catch (error) {
    if (error.response) {
      return thunkAPI.rejectWithValue(error.response.data.errorMessage);
    } else {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
});

export const getMarkets = createAsyncThunk("agentRecruitment/getMarkets", async (data, thunkAPI) => {
  try {
    const resp = await axios.get(`${process.env.REACT_APP_BASE_URL}api/users/markets`, {
      headers: {
        Authorization: "Bearer " + localStorage.token,
        "Content-Type": "application/json",
      },
    });

    return resp?.data;
  } catch (error) {
    if (error.response) {
      return thunkAPI.rejectWithValue(error.response.data.message);
    } else {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
});
